import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DISTRICTS_REQUEST = "FETCH_DISTRICTS_REQUEST";
export const FETCH_DISTRICTS_SUCCESS = "FETCH_DISTRICTS_SUCCESS";
export const FETCH_DISTRICTS_FAILURE = "FETCH_DISTRICTS_FAILURE";

export const FETCH_MUNICIPALITIES_REQUEST = "FETCH_MUNICIPALITIES_REQUEST";
export const FETCH_MUNICIPALITIES_SUCCESS = "FETCH_MUNICIPALITIES_SUCCESS";
export const FETCH_MUNICIPALITIES_FAILURE = "FETCH_MUNICIPALITIES_FAILURE";

// Fetch Districts
export const fetchDistricts = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DISTRICTS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/get-districts`, {
        headers: { Authorization: token },
      });

      if (response?.data?.meta?.status) {
        dispatch({ type: FETCH_DISTRICTS_SUCCESS, payload: response.data.data });
      } else {
        dispatch({
          type: FETCH_DISTRICTS_FAILURE,
          payload: response?.data?.meta?.message || "Failed to fetch districts",
        });
        toast.error(response?.data?.meta?.message || "Failed to fetch districts");
      }
    } catch (error) {
      dispatch({
        type: FETCH_DISTRICTS_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error(error.response?.data?.meta?.message || "District fetch error");
    }
  };
};

// Fetch Municipalities
export const fetchMunicipalities = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_MUNICIPALITIES_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/get-municipalities`, {
        headers: { Authorization: token },
      });

      if (response?.data?.meta?.status) {
        dispatch({ type: FETCH_MUNICIPALITIES_SUCCESS, payload: response.data.data });
      } else {
        dispatch({
          type: FETCH_MUNICIPALITIES_FAILURE,
          payload: response?.data?.meta?.message || "Failed to fetch municipalities",
        });
        toast.error(response?.data?.meta?.message || "Failed to fetch municipalities");
      }
    } catch (error) {
      dispatch({
        type: FETCH_MUNICIPALITIES_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error(error.response?.data?.meta?.message || "Municipality fetch error");
    }
  };
};
